// Brand constants
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_heavy-pro/artifacts/bgzf3czi_7.png";
export const COMPANY_NAME = "Tara Autohub";
export const COMPANY_LEGAL_NAME = "Tara Autohub Private Limited";
export const BRAND_SLOGAN = "Partnering Trust";
export const REG_OFFICE = "Digha Ashiana Road, Patna, 800011 Bihar";
export const ADMIN_BASE = "/admin";
